import { defineCustomElement } from '../../internal/define.js';

class PinegaHero extends HTMLElement {}

defineCustomElement('pinega-hero', PinegaHero);
